import Breadcrumbs from '@/components/Breadcrumbs';
import Portal from '@/components/Portal';
import usePage from '@/hooks/use-page';
import { useEffect, useRef, useState } from 'react';
import NotificationPage from '@/components/NotificationPage/index'
import useNotifications from '@/hooks/use-notification-popup/useNotifications';

const Page = () => {
	/*=================================================
		General
	/================================================*/
	const [title] = useState('Notifications')
	const { breadcrumbsItems } = usePage({ title: title, breadcrumbs: [title] });
	const { unseenCount, isActive: showNotificationsPopup, notificationArr, onlyUnRead, loading, handleRedirect, markReadNotificationItem, showUnreadNotifications, initNotifications, getAllNotifications, getAllUnseenNotificationsCount, markNotificationsAsSeen, handlePopup, markReadAllNotifications, pivotNotification, setIsActive } = useNotifications()

	const childRef = useRef()

	function handleChildScroll(e) {
		if (childRef.current) {
			childRef.current.handleNotificationListScroll(e, true)
		}
	}

	useEffect(() => {
		// Add the event listener when the component mounts
		window.addEventListener('scroll', handleChildScroll);

		// Remove the event listener when the component unmounts
		return () => {
			window.removeEventListener('scroll', handleChildScroll);
		};
	}, []);

	return (
		<>
			<Portal id="bread">
				<Breadcrumbs items={breadcrumbsItems} />
			</Portal>

			<div className='notification-page'>
				<NotificationPage
					ref={childRef}
					notificationType={"page"}
					isActive={showNotificationsPopup}
					pivotNotification={pivotNotification}
					unseenCount={unseenCount}
					notificationArr={notificationArr}
					onlyUnRead={onlyUnRead}
					handlePopup={handlePopup}
					getAllUnseenNotificationsCount={getAllUnseenNotificationsCount}
					getAllNotifications={getAllNotifications}
					markNotificationsAsSeen={markNotificationsAsSeen}
					markReadNotificationItem={markReadNotificationItem}
					markReadAllNotifications={markReadAllNotifications}
					showUnreadNotifications={showUnreadNotifications}
					initNotifications={initNotifications}
					handleRedirect={handleRedirect}
					setIsActive={setIsActive}
					loading={loading}
				/>
			</div>
		</>
	)
}

export default Page
